export function formatApiError(err) {
  if (!err) return "Something went wrong. Please try again.";
  if (typeof err === "string") return err;

  const data = err?.response?.data;
  const detail = data?.detail;

  if (typeof detail === "string") return detail;

  if (Array.isArray(detail)) {
    const parts = detail
      .map((entry) => {
        if (!entry) return null;
        if (typeof entry === "string") return entry;
        if (typeof entry === "object") {
          const msg = entry.msg || entry.message;
          if (msg) {
            const loc = Array.isArray(entry.loc) ? entry.loc : [];
            const field = loc.length ? String(loc[loc.length - 1]) : "";
            return field ? `${field}: ${msg}` : String(msg);
          }
          try {
            return JSON.stringify(entry);
          } catch {
            return "Invalid request.";
          }
        }
        return String(entry);
      })
      .filter(Boolean);
    if (parts.length) return parts.join(" � ");
    return "Invalid request.";
  }

  if (detail && typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    if (typeof detail.message === "string") return detail.message;
    try {
      return JSON.stringify(detail);
    } catch {
      return "Invalid request.";
    }
  }

  if (typeof data?.message === "string") return data.message;
  if (typeof err?.message === "string") return err.message;

  try {
    return JSON.stringify(data ?? err);
  } catch {
    return "Something went wrong. Please try again.";
  }
}
